export enum CONTENTS {
    /**
     * @value This content is archived and only visible to editors.
     * @description Description of the content status notification on an archived status
     */
    ARCHIVED_STATUS_NOTIFICATION = 'CONTENTS.ARCHIVED_STATUS_NOTIFICATION',
    /**
     * @value The content has been successfully archived
     */
    ARCHIVE_SUCCESS = 'CONTENT_CHANGE_STATUS_ARCHIVE_SUCCESS',
    /**
     * @value Archive content?
     */
    CONFIRM_ARCHIVE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE',
    /**
     * @value Unarchive content?
     */
    CONFIRM_UNARCHIVE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE',
    /**
     * @value Unpublish content?
     */
    CONFIRM_UNPUBLISH = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH',
    /**
     * @value Content expiring soon
     */
    CONTENT_EXPIRING_SOON = 'CONTENTS.CONTENT_EXPIRING_SOON',
    /**
     * @value Content not published yet
     */
    CONTENT_NOT_PUBLISHED_YET = 'CONTENTS.CONTENT_NOT_PUBLISHED_YET',
    /**
     * @value Content published
     * @description Text of a notification when a content is published
     *
     */
    CONTENT_PUBLISHED = 'CONTENTS.CONTENT_PUBLISHED',
    /**
     * @value To increase the visibility of this content, you can now promote it.
     * @description Text of a notification letting the user know what she can do once her piece of content has been published
     */
    CONTENT_PUBLISHED_NOTIFICATION_DESCRIPTION = 'CONTENTS.CONTENT_PUBLISHED_NOTIFICATION_DESCRIPTION',
    /**
     * @value Everyone who has access to this site (group All)
     * @description Specific text for when the only the "All" group is selected.
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_ALL_FEED = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.ALL_FEED',
    /**
     * @value Change settings
     * @description Text on the cancel button of the notification alert dialog when creating contents.
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_CHANGE_SETTINGS = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.CHANGE_SETTINGS',
    /**
     * @value {"one":"The following group will be notified of the content publication:","other":"The following groups will be notified of the content publication:"}
     * @description Text set inside the notification alert dialog when creating contents and a the feeds are shown as a list.
     *
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_FEED_LIST_MESSAGE = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.FEED_LIST_MESSAGE',
    /**
     * @value Publish & notify
     * @description Text on the confirmation button of the notification alert dialog when creating contents.
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_PUBLISH = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.PUBLISH',
    /**
     * @value <strong>%FEED%</strong> will receive a notification.
     * @description Text set inside the notification alert dialog when creating contents and a single feed has been selected.
     *
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_SINGLE_FEED = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.SINGLE_FEED',
    /**
     * @value Publish and send notifications
     * @description Title of the notification alert dialog when creating contents.
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_TITLE = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.TITLE',
    /**
     * @value Content unpublished
     */
    CONTENT_UNPUBLISHED = 'REPORTS.ACCEPT_REPORT_CONTENT_SUCCESS',
    /**
     * @value Translate to
     * @description Displays the label oh the translate action
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_OFF_ACTION = 'FRONT.CONTEXTUAL_ACTIONS.TRANSLATION_OFF_ACTION',
    /**
     * @value Translated in
     * @description Displays the label of the translate action
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_ON_ACTION = 'FRONT.CONTEXTUAL_ACTIONS.TRANSLATION_ON_ACTION',
    /**
     * @value Are you sure you want to delete this content?
     */
    DELETE_CONFIRM_CONTENT = 'CONTENT_DELETE_DESCRIPTION',
    /**
     * @value Remove the content
     */
    DELETE_CONFIRM_TITLE = 'CONTENT_DELETE',
    /**
     * @value Content deleted successfully
     */
    DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS',
    /**
     * @value Display publication
     * @description Menu item to display the publication
     */
    DISPLAY_PUBLICATION = 'CONTENTS.DISPLAY_PUBLICATION',
    /**
     * @value Draft in progress
     */
    DRAFT_IN_PROGRESS = 'CONTENT.LAST_REVISION.DRAFT',
    /**
     * @value This content is unpublished and only visible to editors.
     */
    DRAFT_STATUS_NOTIFICATION = 'CONTENTS.DRAFT_STATUS_NOTIFICATION',
    /**
     * @value Editors
     */
    EDITORS = 'CONTENT_SETTINGS_EDITORS',
    /**
     * @value Edit content
     * @description Froala button name
     */
    EDIT_CONTENT = 'FRONT.FROALA.EDITCONTENT',
    /**
     * @value Edit this content
     * @description Text used on buttons to redirect the user to the content edition of the currently seen content
     */
    EDIT_THIS_CONTENT = 'CONTENTS.EDIT_THIS_CONTENT',
    /**
     * @value This content is expired and only visible to editors.
     */
    EXPIRED_STATUS_NOTIFICATION = 'CONTENTS.EXPIRED_STATUS_NOTIFICATION',
    /**
     * @value This content will expire in less than 10 days.
     * @description Text displayed on content status notification when the content will soon expire
     */
    EXPIRES_SOON_STATUS_NOTIFICATION = 'CONTENTS.EXPIRES_SOON_STATUS_NOTIFICATION',
    /**
     * @value Archived pieces of content can be found under the “Archived” filter.
     */
    EXPLAIN_ARCHIVE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE',
    /**
     * @value The content <strong>%CONTENT_NAME%</strong> will go back to the "Draft" status.
     */
    EXPLAIN_UNARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_ONE',
    /**
     * @value The content <strong>%CONTENT_NAME%</strong> will not be visible anymore and will go back to the “Draft” status.
     */
    EXPLAIN_UNPUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_ONE',
    /**
     * @value A group is required
     */
    FEED_REQUIRED = 'FEED_REQUIRED',
    /**
     * @value Content up to date?
     * @description Title on the content status notification displayed on published content with a draft version available
     */
    IS_CONTENT_UP_TO_DATE = 'CONTENTS.IS_CONTENT_UP_TO_DATE',
    /**
     * @value New content
     * @description Title of the second section of the contribution menu
     */
    NEW_CONTENT = 'FRONT.CONTRIBUTION_MENU.NEW_CONTENT',
    /**
     * @value There is no content.
     * @description Text explaining there is no content to show (in a list or in a search result)
     */
    NO_CONTENT = 'CONTENTS.NO_CONTENT',
    /**
     * @value This content has a newer version awaiting validation.
     * @description Text displayed on a published content status notification when a a new version is waiting validation
     */
    PUBLISHED_TO_VALIDATE_STATUS_NOTIFICATION = 'CONTENTS.PUBLISHED_TO_VALIDATE_STATUS_NOTIFICATION',
    /**
     * @value This content has a newer version in draft form.
     * @description Text displayed on a published content status notification when a new draft version is available
     */
    PUBLISHED_WITH_DRAFT_STATUS_NOTIFICATION = 'CONTENTS.PUBLISHED_WITH_DRAFT_STATUS_NOTIFICATION',
    /**
     * @value Are you sure you want to publish this content?
     */
    PUBLISH_CONFIRM_CONTENT = 'CONTENT_SET_TO_LIVE_DESCRIPTION',
    /**
     * @value This content is not published as it has been refused after review. It is only visible to editors.
     * @description Status notification description when a content has been refused after a review
     */
    REFUSED_STATUS_NOTIFICATION = 'CONTENTS.REFUSED_STATUS_NOTIFICATION',
    /**
     * @value Do you really wish to refuse the current version? The document will return to the draft state with the message below displayed for the editors.
     */
    REQUEST_REVISION_CONFIRM_DIALOG_CONTENT = 'ADMIN_WORKFLOW_REFUSE_DESCR',
    /**
     * @value Request revision
     * @description The label of the button to reject a content publication request.
     */
    REQUEST_REVISION_LABEL = 'DESIGNER.REFUSE_CONTENT_PUBLICATION_LABEL',
    /**
     * @value Review workflow
     */
    REVIEW_WORKFLOW_LABEL = 'CONTENT.REVIEW_WORKFLOW_LABEL',
    /**
     * @value Revision requested
     * @description A message displayed in the designer to inform the user that the last revision submitted for review has been refused.
     */
    REVISION_REQUESTED = 'DESIGNER.REVISION_REQUESTED',
    /**
     * @value This content is not yet published and only visible to editors.
     */
    SCHEDULED_STATUS_NOTIFICATION = 'CONTENTS.SCHEDULED_STATUS_NOTIFICATION',
    /**
     * @value Select content type
     * @description Placeholder displayed in the content type picker multiple
     */
    SELECT_CONTENT_TYPE = 'CONTENT.SELECT_CONTENT_TYPE',
    /**
     * @value Highlighted for
     */
    SETTINGS_HIGHLIGHTED_FEEDS = 'CONTENT_SETTINGS_HIGHLIGHTED_FEEDS',
    /**
     * @value Define to whom the content will be pushed to (in certain widgets)
     */
    SETTINGS_HIGHLIGHTED_FEEDS_HELP = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER',
    /**
     * @value Visible by
     */
    SETTINGS_VISIBLE_BY = 'CONTENT_SETTINGS_VISIBLE_BY',
    /**
     * @value Select at least one Group or Space
     * @description "Space" should not be translated, it's a feature name.
     */
    SETTINGS_VISIBLE_BY_ERROR = 'CONTENT_SETTINGS.VISIBLE_BY_ERROR',
    /**
     * @value Visible by Group
     * @description Label of a group selection component
     */
    SETTINGS_VISIBLE_BY_GROUP = 'CONTENT_SETTINGS.VISIBLE_BY_GROUP',
    /**
     * @value Define which Group members can see this content
     * @description Define visibility of a content by Group
     */
    SETTINGS_VISIBLE_BY_GROUP_HELPER = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_GROUP_HELPER',
    /**
     * @value Define who can see the content
     */
    SETTINGS_VISIBLE_BY_HELP = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_HELPER',
    /**
     * @value Visible by Space
     * @description "Space" should not be translated, it's a feature name.
     */
    SETTINGS_VISIBLE_BY_SPACE = 'CONTENT_SETTINGS.VISIBLE_BY_SPACE',
    /**
     * @value Define which Space members can see this content
     * @description "Space" is a feature name and should not be translated
     */
    SETTINGS_VISIBLE_BY_SPACE_HELPER = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_SPACE_HELPER',
    /**
     * @value Go to the content administration to manage this content.
     * @description Text used in the content status notification to inform the user that he can edit the content to change the status
     */
    STATUS_NOTIFICATION_DESCRIPTION = 'CONTENTS.STATUS_NOTIFICATION_DESCRIPTION',
    /**
     * @value Submitted for review
     * @description A message in the designer informing the user that the currently edited content is currently submitted for review.
     */
    SUBMITTED_FOR_REVIEW_MESSAGE = 'DESIGNER.SUBMITTED_FOR_REVIEW_MESSAGE',
    /**
     * @value This content will remain uneditable until an administrator reviews and publishes it.
     * @description The content of the confirm dialog displayed when a user submit a content for review within the content editor context.
     */
    SUBMIT_FOR_REVIEW_CONFIRM_DIALOG_CONTENT = 'DESIGNER.SUBMIT_FOR_REVIEW_CONFIRM_DIALOG_CONTENT',
    /**
     * @value Submit for review
     * @description The label of the button to submit a content update for review in the designer.
     */
    SUBMIT_FOR_REVIEW_LABEL = 'DESIGNER.SUBMIT_FOR_REVIEW_LABEL',
    /**
     * @value {"one":"You can unarchive this content at any time.","other":"You can unarchive these pieces of content at any time."}
     */
    TO_REVERSE_ARCHIVE = 'CONTENT_ADMIN.TO_REVERSE_ARCHIVE',
    /**
     * @value This content is not published and awaiting validation to be published. It is only visible to editors.
     * @description Text displayed on content status notification when the content is awaiting a validation after review asked
     */
    TO_VALIDATE_STATUS_NOTIFICATION = 'CONTENTS.TO_VALIDATE_STATUS_NOTIFICATION',
    /**
     * @value Content types
     */
    TYPES = 'CONTENT_TYPES',
    /**
     * @value The content has been successfully unarchived
     */
    UNARCHIVE_SUCCESS = 'CONTENT_CHANGE_STATUS_UNARCHIVE_SUCCESS',
    /**
     * @value Unpublish
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * @value Saved changes not published
     * @description A message displayed in the designer to warn the user that the last saved version is not published yet.
     */
    UNPUBLISHED_SAVED_CHANGES_WARNING_MESSAGE = 'DESIGNER.UNPUBLISHED_SAVED_CHANGES_WARNING_MESSAGE',
    /**
     * @value The content has been successfully unpublished
     */
    UNPUBLISH_SUCCESS = 'CONTENT_CHANGE_STATUS_UNPUBLISH_SUCCESS',
    /**
     * @value New version refused
     */
    VERSION_REFUSED = 'CONTENT.LAST_REVISION.REFUSED',
    /**
     * @value New version to validate
     */
    VERSION_TO_VALIDATE = 'CONTENT.LAST_REVISION.TO_VALIDATE',
    /**
     * @value Write on behalf of
     */
    WRITE_ON_BEHALF_OF = 'CONTENT_SETTINGS_WRITE_INSTEAD_OF',
    /**
     * @value Writing on behalf of
     * @description Text to tell the user that his content is written on behalf of a specific user
     */
    WRITING_ON_BEHALF_OF = 'CONTENTS.WRITING_ON_BEHALF_OF',
    /**
     * @value Written on behalf of
     */
    WRITTEN_ON_BEHALF_OF = 'CONTENTS.WRITTEN_ON_BEHALF_OF',
}
